import React from 'react'
import CookieConsent from 'react-cookie-consent'
import { FiX } from 'react-icons/fi'
import { privacyPolicyURL } from '../services/defaultProps'
import '../styles/components/CookiesNotification.css'

const CookiesNotification = () => {
  return (
    <CookieConsent
      location='bottom'
      buttonText='Concordar'
      containerClasses='cookies-notification-container'
      contentClasses='cookies-notification-content'
      buttonClasses='cookies-notification-button'
      buttonWrapperClasses='cookies-notification-button-container'
      sameSite='strict'
      enableDeclineButton
      declineButtonClasses='cookies-notification-decline'
      declineButtonText={<FiX color='white' size={20} />}
    >
      <p>Este site usa cookies e dados pessoais de acordo com a nossa<br /><a target='_blank' rel='noopener' href={privacyPolicyURL}>Política de Privacidade</a>.</p>
    </CookieConsent>
  )
}

export default CookiesNotification



// WEBPACK FOOTER //
// ./src/components/CookiesNotification.js